import { compose } from 'ramda';

const stripNonDigits = mobileNumber => mobileNumber.replace(/[^\d]+/g, '');
const stripPrefix = mobileNumber =>
  mobileNumber.replace(/^(0044|440|44|0)/, '');
const addPrefix = mobileNumber => `+44${mobileNumber}`;

const formatE164 = compose(addPrefix, stripPrefix, stripNonDigits);

const e164 = mobileNumber => {
  try {
    return formatE164(mobileNumber);
  } catch (e) {
    return null;
  }
};

export { e164 };
export default { e164 };
